export function isValidSubdomain(subdomain: string) {
  return /^(?!-)[a-z0-9-]{1,63}(?<!-)$/.test(subdomain);
}
